export default __webpack_public_path__ + "assets/images/0537a8f5f35ffe53c648789242e5669e.svg";